import { FC } from 'react';
import { Pagination } from '@mui/material';

import { shouldShowPagination } from '../../../../../utils/pagination.utils';

import styles from './DiscoverPagination.module.scss';

type DiscoverPaginationProps = {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
};

const DiscoverPagination: FC<DiscoverPaginationProps> = ({ page, totalPages, onPageChange, disabled = false }) => {
  if (!shouldShowPagination(totalPages)) {
    return null;
  }

  return (
    <Pagination
      className={styles.discoverPagination}
      count={totalPages}
      page={page}
      disabled={disabled}
      onChange={(_, nextPage) => onPageChange(nextPage)}
      shape="rounded"
      color="primary"
    />
  );
};

export default DiscoverPagination;
